import { useTranslation } from "react-i18next"



export default function getSafetyCardColor(alarm) {
    switch (alarm.status) {
        case "OPEN": return "bg-danger bg-opacity-75"
        case "IN_PROGRESS": return "bg-primary bg-opacity-25"
        case "CANCELED": return "bg-dark"
        case "CLOSED": return "bg-success bg-opacity-25"
        default: return "bg-dark"
    }
}


export function getSafetyIcon(alarm) {
    switch (alarm.type) {
        case "SOS": return ""
        case "REMOTE": return <i className="fa-solid fa-tower-broadcast"></i>
        case "NO_ACTIVITY": return <i className="fa-solid fa-ban"></i>
        case "FALL_DETECT": return <i className="fa-solid fa-person-falling"></i>
        case "HIGH_HR":
        case "LOW_HR": return <i className="fa-solid fa-heart-circle-exclamation"></i>
        default: return <i className="fa-solid fa-question"></i>
    }
}


export function SafetyStatusBadge({ alarm }) {

    const [t] = useTranslation(["global", "safety"])

    let color = "dark"
    switch (alarm.status) {
        case "OPEN": color = "bg-danger "
        case "IN_PROGRESS": color = "bg-primary "
        case "CANCELED": color = "bg-dark"
        case "CLOSED": color = "bg-success "
    }


    return <span className={`badge rounded-pill ${color}`}>
        {t(`safety:entity.alarm.status.${alarm.status}`).toUpperCase()}
    </span>
}


